/* ============================================================
   Voucher carousel — modal interaction
   Click a voucher card → opens modal with larger image +
   optional Download and Visit-link action buttons.
   ============================================================ */
(function () {
  'use strict';

  if (typeof document === 'undefined') return;

  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var openModal = null;
  var lastFocused = null;

  function show(modal, trigger) {
    if (!modal) return;
    lastFocused = trigger;
    populate(modal, trigger);
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('voucher-modal--open');
    document.documentElement.classList.add('voucher-modal-locked');
    openModal = modal;
    // Focus close button on next tick (after transition kicks in)
    window.requestAnimationFrame(function () {
      var closeBtn = modal.querySelector('.voucher-modal__close');
      if (closeBtn) closeBtn.focus();
    });
  }

  function hide(modal) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('voucher-modal--open');
    document.documentElement.classList.remove('voucher-modal-locked');
    openModal = null;
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
    lastFocused = null;
  }

  function populate(modal, trigger) {
    var d = trigger.dataset;
    var img = modal.querySelector('.voucher-modal__image');
    var title = modal.querySelector('.voucher-modal__title');
    var download = modal.querySelector('[data-voucher-modal-download]');
    var link = modal.querySelector('[data-voucher-modal-link]');

    var alt = d.alt || 'Voucher';
    if (img) {
      img.src = d.image || '';
      img.alt = alt;
    }
    if (title) {
      title.textContent = alt;
    }

    if (download) {
      if (d.downloadUrl) {
        download.href = d.downloadUrl;
        download.textContent = d.downloadLabel || 'Download';
        download.hidden = false;
      } else {
        download.removeAttribute('href');
        download.hidden = true;
      }
    }

    if (link) {
      if (d.linkUrl) {
        link.href = d.linkUrl;
        link.textContent = d.linkLabel || 'Visit link';
        link.hidden = false;
      } else {
        link.removeAttribute('href');
        link.hidden = true;
      }
    }
  }

  function onClick(e) {
    var trigger = e.target.closest('[data-voucher-trigger]');
    if (trigger) {
      e.preventDefault();
      var modalId = trigger.getAttribute('data-modal-target');
      var modal = modalId ? document.getElementById(modalId) : null;
      if (modal) show(modal, trigger);
      return;
    }
    var closer = e.target.closest('[data-voucher-modal-close]');
    if (closer && openModal) {
      e.preventDefault();
      hide(openModal);
    }
  }

  function onKeydown(e) {
    if (!openModal) return;
    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      hide(openModal);
      return;
    }
    if (e.key === 'Tab' || e.keyCode === 9) {
      // Trap focus inside the open modal
      var focusables = Array.prototype.slice
        .call(openModal.querySelectorAll(FOCUSABLE))
        .filter(function (el) { return !el.hidden && el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKeydown);

  // Shopify theme editor: re-hook is unnecessary since we use delegation,
  // but close any open modal when the merchant switches sections.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      if (openModal) hide(openModal);
    });
    document.addEventListener('shopify:section:select', function () {
      if (openModal) hide(openModal);
    });
  }
})();
